export const CAMPAING_CHECKED_SETTINGS = 'Campaign//CHECKED_SETTINGS'


// WEBPACK FOOTER //
// ./src/app/adobeAcrobat/vuex/mutation-types.js